import React from 'react';

import { PropertySelectField } from '@paragon/client-tools';
import { Line } from '@paragon/contract-library';

import { RootState } from '../store';
import { useAppSelector } from './hooks';

interface LineSelectorProps {
  selectedLineGuid: string | null;
  submit: (lineGuid: string) => void;
  error?: boolean;
  placeholderTextOverride?: string;
}

export function LineSelector(props: LineSelectorProps) {
  const { error, placeholderTextOverride, selectedLineGuid, submit } = props;
  const lines = useAppSelector((state: RootState) => state.lines);

  return (
    <PropertySelectField<Line>
      property={placeholderTextOverride ?? 'Line'}
      value={selectedLineGuid ? (lines[selectedLineGuid] ?? null) : null}
      options={Object.values(lines)}
      getName={(line) => line?.name}
      getValue={(line) => line?.guid}
      submit={(line) => submit(line.guid)}
      error={error}
      margin="none"
    />
  );
}
